import "./ErrorStyle.scss";
import { IJSLComponent, IJSLVNode } from "jsl-render";
import {mapUrl } from "../../helper/mapUrl";
import { ContactBoxComponent } from "../service/ContactBoxComponent";

export class ErrorComponent implements IJSLComponent {

    private message: string = "Es tut uns leid, ein Fehler ist aufgetreten. Bitte versuchen Sie es in einigen Minuten erneut.";
    public constructor(message: string) {
        if (message != null && message !== "") {
            this.message = message;
        }
    }
    public render(): IJSLVNode {
        return <div class="error-comp">
            <div class="info-box" id="error-message">
                <p>{this.message}</p>
            </div>
            <div class="center"><img src={mapUrl("Content/images/smiley.png")} style="height:12rem"/></div>
            <div class="info-box">
                {new ContactBoxComponent()}
            </div>
        </div>;
    }
}
